import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { IMessagingEnvironment } from '../../core/interfaces/IMessagingEnvironment';
import { MESSAGING_CONFIG } from '../../core/messaging-config';
import { MessagingEnvironmentService } from '../../core/services/messaging-environment.service';
import { AuthInterceptor } from './services/auth.interceptor';
import { AuthenticationService } from './services/authentication.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }, AuthenticationService],
})
export class UserModule {
  public static messagingEnvironment: IMessagingEnvironment;

  static forRoot(options: { messagingEnvironment: IMessagingEnvironment }): ModuleWithProviders<UserModule> {
    this.messagingEnvironment = options.messagingEnvironment;

    return {
      ngModule: UserModule,
      providers: [MessagingEnvironmentService, { provide: MESSAGING_CONFIG, useValue: this.messagingEnvironment }],
    };
  }
}
